import {RootStore} from "./rootStore";
import {action, observable, makeObservable, runInAction} from "mobx";
import {ICard} from '../models/card';


export default class CardsStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      cards: observable,
      cardChosen: observable,
      card2Chosen: observable,
      mobileCardShown: observable,
      setCardData: action,
      resetCards: action
    });
  }

  cards:ICard[] = [];
  cardChosen:ICard|null = null;
  card2Chosen:ICard|null = null;
  mobileCardShown:number = 1;

  setCardChosen = (card:ICard|null) => {
    this.cardChosen = card;
  };
  setCard2Chosen = (card:ICard|null) => {
    this.card2Chosen = card;
  };
  resetCards = () => {
    this.cardChosen = null;
    this.card2Chosen = null;
    this.mobileCardShown = 1;
  }
  setMobileCardShown = (cardShown:number) => {
    this.mobileCardShown = cardShown;
  }
  flipCard = () => {
    this.mobileCardShown =  2 - ((this.mobileCardShown + 1) % 2);
  }

  setCardData = (cardData:ICard[]) => {
    runInAction(() => {

      cardData.forEach(element => {
        element.subjectId = element.terms.nodes.find(term => term.taxonomyName == 'subject')?.termTaxonomyId;
        element.formId = element.terms.nodes.find(term => term.taxonomyName == 'form')?.termTaxonomyId;
        element.subjectTitle = element.terms.nodes.find(term => term.taxonomyName == 'subject')?.name;
      });
      this.cards = cardData;
    });
  }

}
